module.exports = __webpack_public_path__ + "static/media/Sampaguita.fa2c8435.png";